import { ICafeListItemViewModel } from "@dining/api-client";
import { FluentProvider, Tab, TabList, webLightTheme } from "@fluentui/react-components";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeUpdateCafeMode, openPanel } from "../../reducers/diningReducer";
import { cafeSelector, updateCafeModeSelector } from "../../selectors/diningSelector";
import { UpdateCafeForm } from "./UpdateCafeForm";

export const UpdateCafe = () => {
  const dispatch = useDispatch();

  const selectedCafe: ICafeListItemViewModel | undefined = useSelector(cafeSelector);
  const updateCafeMode: string = useSelector(updateCafeModeSelector);

  useEffect(() => {
    dispatch(openPanel());
  }, [dispatch]);

  return (
    <FluentProvider theme={webLightTheme} targetDocument={typeof window !== "undefined" ? window.document : undefined}>
      <TabList
        aria-label="Add or Edit Cafe Selector"
        selectedValue={updateCafeMode}
        onTabSelect={(_, data) => dispatch(changeUpdateCafeMode(data.value as string))}
      >
        <Tab value="Add">Add cafe</Tab>

        {selectedCafe && <Tab value="Edit">Edit cafe</Tab>}
      </TabList>

      {updateCafeMode === "Add" && <UpdateCafeForm />}
      {updateCafeMode === "Edit" && selectedCafe && <UpdateCafeForm />}
    </FluentProvider>
  );
};

export default UpdateCafe;
